import React, { createContext, useContext, useEffect, useState } from "react"

export const THEME_STORAGE_KEY = "cedcreate-theme"

const ThemeContext = createContext(null)

const getThemeFromDom = () =>
  typeof document !== "undefined" &&
  document.documentElement.classList.contains("dark")
    ? "dark"
    : "light"

export const ThemeProvider = ({ children }) => {
  const [theme, setTheme] = useState(getThemeFromDom)

  useEffect(() => {
    const shouldBeDark = theme === "dark"
    const isDarkOnDom = document.documentElement.classList.contains("dark")

    if (isDarkOnDom !== shouldBeDark) {
      document.documentElement.classList.toggle("dark", shouldBeDark)
    }

    try {
      localStorage.setItem(THEME_STORAGE_KEY, theme)
    } catch (e) {}
  }, [theme])

  const toggleTheme = () => {
    setTheme((current) => (current === "dark" ? "light" : "dark"))
  }

  return (
    <ThemeContext.Provider
      value={{ theme, toggleTheme, isDark: theme === "dark" }}
    >
      {children}
    </ThemeContext.Provider>
  )
}

export const useTheme = () => {
  const context = useContext(ThemeContext)
  if (!context) {
    throw new Error("useTheme must be used within a ThemeProvider")
  }
  return context
}
